import { Card, Tag } from 'antd';
import { FaTimesCircle } from 'react-icons/fa';
import styled from 'styled-components';
import { Table } from '~/components/Table';

export const TableView = styled(Table)`
  margin-top: 15px;

  .ant-table-thead > tr > th {
    background-color: #2e394b;
    color: #f5f5f5;
  }
`;

export const RedTimes = styled(FaTimesCircle)`
  fill: red !important;
  font-size: 15px;
  vertical-align: middle;
`;

export const MobileCard = styled(Card)`
  width: 48%;

  .ant-card-head {
    background-color: #2e394b;
    color: #f5f5f5;
    text-align: center;
  }

  .ant-card-body {
    text-align: center;
  }
`;

export const TitleTag = styled(Tag)`
  display: flex;
  align-items: ${(props) => props.align ?? 'center'};
  justify-content: ${(props) => props.justify ?? 'center'};
  width: 100%;
  height: ${(props) => props.height ?? '50px'};
  margin-top: ${(props) => props.marginTop ?? '60px'};
  margin-right: ${(props) => props.marginRight ?? '0'};
  margin-bottom: ${(props) => props.marginBottom ?? '60px'};
  margin-left: ${(props) => props.marginLeft ?? '0'};
`;
